<template>
  <v-autocomplete
    ref="box"
    v-model="internalValue"
    :loading="loading"
    :items="items"
    item-text="title"
    item-value="_id"
    label="صندوق"
    @focus="onFocus"
    v-bind="$attrs"
    v-on="$listeners"
    :rules="requiredRules"
    no-data-text="اطلاعاتی موجود نیست..."
    prepend-inner-icon="mdi-cash" />
</template>

<script>
import vueAxios from '../functions/vueAxios'

export default {
  name: 'MyBoxes',
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [v => !!v || 'فیلد الزامی'],
      hasDefaultSet: false,
      internalValue: this.value,
    }
  },
  watch: {
    value(val) {
      this.internalValue = val
    },
    internalValue(val) {
      this.$emit('input', val) // تغییرات را به والد اعلام می‌کنیم
    }
  },
  methods: {
    async retrieveData() {
      this.loading = true
      try {
        const res = await vueAxios.get(`/boxes/name`)
        if (res) {
          this.items = res.map(item => ({
            _id: item._id,
            title: `${item.id}-${item.title}`
          }))
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    onFocus() {
      if (!this.hasDefaultSet && this.items && this.items.length && !this.internalValue) {
        this.internalValue = this.items[0]._id
        this.hasDefaultSet = true
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
}
</script>
